import moment from 'moment';

// console.log(moment(data.start, 'HH:mm:ss').utc().format('HH:mm:ss'));

export enum TimeFormatTypes {
  HH_mm_ss = 'HH:mm:ss',
  HH_mm = 'HH:mm',
}

export const convertLocalTimeToUtc = (time: string) => {
  return moment(time, TimeFormatTypes.HH_mm_ss).utc().format(TimeFormatTypes.HH_mm_ss);
};

export const convertUtcTimeToLocal = (time: string) => {
  return moment.utc(time, TimeFormatTypes.HH_mm_ss).local().format(TimeFormatTypes.HH_mm_ss);
};
